<template>
  <div class="large-event-banner">
    <img
      class="banner-image"
      src="@/assets/img/landing/price/first-subscription-event.png"
      alt="newSubscriptionBanner" />

    <!-- 블러 오버레이 -->
    <div class="blur-overlay"></div>

    <!-- 메인 컨텐츠 -->
    <div class="banner-content">
      <!-- 섹션 1: 이벤트 헤더 + CTA -->
      <div class="event-section">
        <div class="event-prefix">
          <img :src="require('@/assets/img/landing//first-sub-sale.png')" class="event-prefix-icon" alt="할인 아이콘" />
          <span class="event-prefix-text">첫 구독 이벤트</span>
        </div>

        <div class="event-content">
          <h2 class="event-title">슈퍼멤버스가 처음이세요?</h2>
          <p class="event-subtitle">20% 할인된 가격으로 <br />3개월 먼저 체험해 보세요!</p>
        </div>

        <div class="cta-section" @click="handleClickCta">
          <button class="cta-button">신규 전용 혜택 받기</button>
        </div>
      </div>

      <!-- 섹션 2: 3개월 플랜 정보 -->
      <div class="plan-section">
        <!-- 가격 정보 -->
        <div class="price-card">
          <div class="price-header-wrapper">
            <div class="price-header">
              <span class="plan-name">3개월 플랜</span>
              <span class="discount-badge">20% 할인</span>
            </div>
            <div class="plan-info">
              <span>최소 보장 인원 24명</span>
            </div>
          </div>

          <div class="price-info-wrapper">
            <div class="price-info">
              <span class="current-price">12만원</span>
              <span class="price-unit">/월</span>
              <span class="vat-info">VAT 별도</span>
              <span class="original-price">150,000원</span>
            </div>
          </div>
        </div>

        <!-- 기능 목록 -->
        <div class="features-list">
          <p class="features-list-title">주요 기능</p>

          <!-- 주요 기능 목록 -->
          <div class="feature-main-list">
            <div v-for="feature in threeMonthFeatures" :key="feature.id" class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="#FFD594" />
              </svg>
              <span class="feature-text">{{ feature.title }}</span>
            </div>
          </div>

          <!-- + 아이콘 -->
          <div class="feature-plus-icon">
            <img :src="require('@/assets/img/landing/plus.png')" class="feature-plus-icon" alt="feature-plus-icon" />
          </div>

          <!-- 추가 혜택 목록 -->
          <div class="feature-additional-list">
            <div v-for="feature in threeMonthAdditionalFeatures" :key="feature.id" class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="#FFD594" />
              </svg>
              <div class="feature-text-wrapper">
                <span class="feature-text">{{ feature.title }}</span>
                <span class="feature-value">추가혜택</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LargeBannerMobile',
  data() {
    return {
      threeMonthFeatures: [
        { id: 1, title: '블로그 키워드 기초 컨설팅' },
        { id: 2, title: '블로그 키워드 순위 리포트' },
        { id: 3, title: '플레이스 키워드 순위 리포트' },
        { id: 4, title: '구글 맵 리뷰 제공' },
        { id: 5, title: '상위 블로거 무제한 모집' },
        { id: 6, title: '매장 비공개 한줄평' },
      ],
      threeMonthAdditionalFeatures: [
        { id: 1, title: '블로그 키워드 전략 컨설팅' },
        { id: 2, title: '플레이스 키워드 컨설팅' },
        { id: 3, title: '플레이스 운영 가이드북 제공' },
      ],
    };
  },
  methods: {
    handleClickCta() {
      this.$emit('click-cta');
    },
  },
};
</script>

<style scoped lang="scss">
.large-event-banner {
  position: relative;
  background: linear-gradient(135deg, #fff0d9 0%, #ffeacc 100%);
  border-radius: 16px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  min-height: 500px;
  margin-top: 40px;
}

.banner-image {
  position: absolute;
  bottom: 0;
  right: 1px;
  width: 429px;
  height: 419px;
  // z-index: 0;
}
.blur-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  // z-index: 2;
}

.banner-content {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

// 섹션 1: 이벤트 헤더 + CTA
.event-section {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .event-prefix {
    padding: 4px 8px;
    border-radius: 8px;
    background: rgba(234, 42, 58, 0.05);
    max-width: 112px;
    display: flex;
    align-items: center;
    gap: 4px;

    .event-prefix-icon {
      width: 20px;
      height: 20px;
      object-fit: contain;
    }

    .event-prefix-text {
      color: var(--primary_light, #ea2a3a);
      font-family: 'Spoqa Han Sans Neo';
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px; /* 150% */
    }
  }

  .event-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .event-title {
    color: var(--default, #3a3a3a);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }

  .event-subtitle {
    color: var(--default, #212121);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px; /* 140%  */
  }

  .cta-section {
    display: flex;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: var(--default, #3a3a3a);
    cursor: pointer;

    .cta-button {
      color: var(--inversed-1, #fff);
      text-align: center;
      font-family: 'Spoqa Han Sans Neo';
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
}

// 섹션 2: 3개월 플랜 정보
.plan-section {
  display: flex;
  padding: 16px 8px 8px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(12px);

  .price-card {
    width: 100%;
    padding: 0 8px;

    .price-header-wrapper {
      margin-bottom: 12px;

      .price-header {
        display: flex;
        align-items: center;
        gap: 8px;

        .plan-name {
          color: var(--default_dark, #202020);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px; /* 142.857% */
        }

        .discount-badge {
          display: flex;
          padding: 2px 8px;
          justify-content: center;
          align-items: flex-start;
          gap: 10px;
          border-radius: 10px;
          color: var(--inversed-1, #fff);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px; /* 133.333% */
          background: var(--Tertiary_light, #0c8aff);
        }
      }

      .plan-info {
        span {
          color: var(--default_light, #808080);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px; /* 116.667% */
        }
      }
    }

    .price-info-wrapper {
      display: flex;
      align-items: baseline;
      gap: 8px;

      .price-info {
        display: flex;
        align-items: baseline;
        gap: 8px;

        .current-price {
          color: var(--default_dark, #202020);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 28px; /* 140% */
        }

        .price-unit {
          color: var(--default_dark, #202020);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px; /* 142.857% */
        }

        .vat-info {
          color: var(--default_light, #808080);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px; /* 150% */
        }
      }

      .original-price {
        color: var(--disabled_dark, #c2c2c2);
        font-family: 'Spoqa Han Sans Neo';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        text-decoration-line: line-through;
      }
    }
  }

  .features-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    .features-list-title {
      color: #202020;
      font-family: 'Spoqa Han Sans Neo';
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      padding: 0 8px;
    }

    .feature-main-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 12px;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(5px);

      .feature-item {
        display: flex;
        align-items: center;
        justify-content: start;
        gap: 4px;

        .feature-icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }

        .feature-text {
          color: var(--default-2, #484848);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px; /* 142.857% */
        }
      }
    }

    .feature-plus-icon {
      display: flex;
      justify-content: center;

      img {
        width: 24px;
        height: 24px;
        object-fit: contain;
      }
    }

    .feature-additional-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 12px;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(5px);

      .feature-item {
        display: flex;
        align-items: center;
        justify-content: start;
        gap: 4px;

        .feature-icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }

        .feature-text-wrapper {
          display: flex;
          align-items: center;
          gap: 4px;
          flex-wrap: wrap;
        }

        .feature-text {
          color: var(--default-2, #484848);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px; /* 142.857% */
        }

        .feature-value {
          display: flex;
          padding: 2px 8px;
          justify-content: center;
          align-items: flex-start;
          gap: 10px;
          border-radius: 10px;
          background: rgba(234, 42, 58, 0.1);
          color: var(--primary_light, #ea2a3a);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px; /* 133.333% */
        }
      }
    }
  }
}
</style>
